export default __webpack_public_path__ + "static/2447-ddd33cf474093d861ab5a79bc201c7f5.gif";